interface Props {
  message: string | null;
}
export function Toast({
  message
}: Props) {
  return <div className={`toast${message ? ' show' : ''}`} data-id="element-274">
      {message || ''}
    </div>;
}